import {
  FINANCE_LOADING,
  FINANCE_LOADED,
  FINANCE_ERROR,
  FINANCE_REFRESHING,
} from '../actions/financeActions';

const initialState = {
  loading: false,
  refreshing: false,
  error: null,
  overview: {
    totalMembers: 0,
    totalPaidMembers: 0,
    complimentaryMembers: 0,
    cancelledMemberships: 0,
    currentMonthRevenueEur: 0,
    currentMonthServerCostsUsd: 0,
    currentMonthServerCostsEur: 0,
    monthlyVelocityEurPerDay: 0,
    projectedMonthlyRevenueEur: 0,
    projectedMonthlyServerCostsEur: 0,
    projectedNetEur: 0,
  },
  charts: {
    revenueByMonth: [],
    serverCostsByMonth: [],
    netByMonth: [],
    paidMembersByMonth: [],
    complimentaryMembersByMonth: [],
    cancellationsByMonth: [],
  },
  tables: {
    monthlyBreakdown: [],
    cancellationReasons: [],
  },
  freshness: null,
  fx: null,
};

const financeReducer = (state = initialState, action) => {
  switch (action.type) {
    case FINANCE_LOADING:
      return {
        ...state,
        loading: true,
        refreshing: false,
        error: null,
      };

    case FINANCE_REFRESHING:
      return {
        ...state,
        refreshing: true,
        error: null,
      };

    case FINANCE_LOADED:
      return {
        ...state,
        loading: false,
        refreshing: false,
        error: null,
        overview: action.payload.overview || initialState.overview,
        charts: action.payload.charts || initialState.charts,
        tables: action.payload.tables || initialState.tables,
        freshness: action.payload.freshness || null,
        fx: action.payload.fx || null,
      };

    case FINANCE_ERROR:
      return {
        ...state,
        loading: false,
        refreshing: false,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default financeReducer;
